( (
  { hooks: { addFilter: addFilterBe } }
) => {
  // eslint-disable-line
  addFilterBe(
    'b3rg_meta_field_exclude_fields',
    'b3rg/meta_field',
    ( defaultValue ) => {
      const otherMeta = [
        '_acf_changed',
        'notification_enabled',
        'notification_text',
        'notification_logo',
        'notification_expiration_time',
        'is_enable_transparent_header',
        'selected_primary_terms',
        'hide_from_list_view',
        'notification_enabled_post_list',
        '_relevanssi_hide_post',
        '_relevanssi_hide_content',
        '_relevanssi_pin_for_all',
        '_relevanssi_pin_keywords',
        '_relevanssi_unpin_keywords',
        '_relevanssi_related_keywords',
        '_relevanssi_related_include_ids',
        '_relevanssi_related_exclude_ids',
        '_relevanssi_related_no_append',
        '_relevanssi_related_not_related',
        '_relevanssi_related_posts',
        '_relevanssi_noindex_reason',
        'inline_featured_image',
        'hs_portal_id',
        'hs_form_id',
        'hs_region',
        'mkt_base_url',
        'mkt_munchkin_id',
        'mkt_form_id',
        'mkt_submit_event',
        'sf_embed_code',
        'response_message',
        'response_heading',
        'heading_tag',
        'response_type',
        'cookie_validity',
        'download',
        'redirect',
        'redirect_download',
        'popup'
      ];
  
      return Array.from( new Set( [ ...defaultValue, ...otherMeta ] ) );
    }
  );

  addFilterBe(
    'b3rg_primary_term_enabled_taxonomies',
    'b3rg/primary_tag',
    // eslint-disable-next-line no-unused-vars
    ( defaultValue ) => {
      const enabledTaxonomies = {
        blog: ['blog-category', 'topic', 'resource-category'],
        resource: ['resource-category', 'event-type'],
      };
      return enabledTaxonomies;
    }
  );

      // eslint-disable-line
  addFilterBe(
    'b3rg_meta_field_include_fields',
    'b3rg/meta_field',
    ( defaultMetaFieldsArray ) => {
      return [
        ...defaultMetaFieldsArray,
        'post_type',
        'author_bio',
        'author_for_post',
        'featured_text',
        'event_start_time'
      ];
    }
  );

  addFilterBe( 'b3rg_meta_field_query', 'b3rg/meta_field', ( defaultValue ) => {
    /* uncomment for use this filter
    const query = {
      status: 'publish',
      include: 1900,
      exclude: 1800,
      ...
    };
    return query;
 */
    return defaultValue;
  } );
} )( wp ); // eslint-disable-line no-undef
